<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    @click:outside="$emit('input', false)"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="700"
    scrollable
  >
    <v-card
      v-if="product"
      color="background"
      max-height="600"
      style="overflow-y: auto"
    >
      <v-row
        v-if="$vuetify.breakpoint.smAndDown"
        no-gutters
      >
        <div class="pt-2 pl-1">
          <v-btn
            icon
            @click="close"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
      </v-row>
      <v-card class="rounded-lg elevation-1 ma-3">
        <v-row
          align="center"
          no-gutters
        >
          <v-col
            class="pa-3"
            cols="3"
          >
            <v-img
              :src="image"
              aspect-ratio="1"
              contain
            />
          </v-col>
          <v-col
            class="pa-3"
            cols="9"
          >
            <div
              v-if="$store.state.showAllInfo"
              class="font-weight-medium"
            >
              id: {{ product.id }}
            </div>
            <div
              class="text-subtitle-1 text-md-h5 font-weight-medium"
              v-text="product.name"
            />
            <div
              class="mt-3"
              style="min-height: 72px"
            >
              <b>Статус: </b>{{ statusText }}
              <div v-if="currentSelectedIngredient">
                <b>Задействован модификатор: </b>{{ currentSelectedIngredient.name }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <one-ingredient-group
        v-for="(ingredientGroup, index) in productIngredientGroups"
        :key="index"
        :product-ingredient-group="ingredientGroup"
        :selected-ingredient="currentSelectedIngredient"
        :is-product-selected="isProductSelected"
        :selectedIngredients="selectedIngredients"
        :disabled="disabled"
        @input="onIngredientSelect"
      />
      <div style="min-height: 65px" />
    </v-card>
  </v-dialog>
</template>

<script>
  import OneIngredientGroup from './OneIngredientGroup'
  import { cloneDeep } from 'lodash'

  export default {
    name: 'OneProductDialog',

    components: {
      OneIngredientGroup
    },

    props: {
      value: Boolean,
      product: Object,
      isProductSelected: Boolean,
      selectedIngredient: Object,
      selectedIngredients: Array,
      disabled: Boolean
    },

    emits: ['input', 'updateIngredients'],

    data: () => ({
      currentSelectedIngredient: null
    }),

    computed: {
      productIngredientGroups() {
        return this.product.product_ingredient_groups
      },

      image() {
        const notFoundImage = '/static/not-found.png'
        if (!this.product) return notFoundImage
        return this.product.image || notFoundImage
      },

      statusText() {
        if (!this.isProductSelected && !this.currentSelectedIngredient) return 'Продукт не выбран'
        let text = 'Продукт выбран'

        if (!this.currentSelectedIngredient) text += ', включая все модификаторы'
        else text += ' частично'

        return text
      }
    },

    methods: {
      close() {
        this.$emit('input', false)
      },
      onIngredientSelect(ingredient) {
        if (this.currentSelectedIngredient && this.currentSelectedIngredient.id === ingredient.id) {
          this.currentSelectedIngredient = null
        } else {
          this.currentSelectedIngredient = ingredient
        }
      }
    },

    watch: {
      value(v) {
        if (v) {
          this.currentSelectedIngredient = this.selectedIngredient
            ? cloneDeep(this.selectedIngredient)
            : null
        } else {
          this.$emit('updateIngredients', {
            selected: this.currentSelectedIngredient
          })
        }
      }
    }
  }
</script>
